import React from 'react';
import { Image } from 'react-bootstrap';
import Button from './Button';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../../css/Shared/TranspotationRejectModal.css';
import success from '../../Assets/TruckVisits/Assets-Desktop/alert.svg';
import RespModal from './RespModal';

function TranspotationRejectModal(props) {
    return(
        <RespModal hasOpen={props.hasOpen}>
        <div className="modalsizeRjectModal" >
            <Image src={success} /><br /><br />
            <div id="modalcontainsuccessaddprofileRjectModal">
                 {props.children}
            </div>
            <div class="cancelresploginbuttonouterRejectModal">
        <Button
                id="cancelresploginbuttonRejectModal"
                type="button"
                class="btn btn-dark"
                onClick={props.onCloseModal}
            >Reject
        </Button>
            </div>
        </div>  
    </RespModal>
    );
}
export default TranspotationRejectModal;
